import RelatedPropertiesCardList, {
  RelatedPropertiesCardListProps
} from '@portalterreno/nextjs-client/portalterreno/components/RelatedPropertiesCardList';
import { Col, Container, Row } from '@portalterreno/react-ui-core/Grid';
import ModalMobile, {
  ModalMobileProps
} from '@portalterreno/react-ui-core/ModalMobile';
import { FC } from 'react';

import CancelButton from '../CancelButton';
import Header from '../Header';
import LeadButton from '../LeadButton';
import ButtonsWrapper from './ButtonsWrapper';
import ContentWrapper from './ContentWrapper';
import Wrapper from './Wrapper';

export type MobileProps = Omit<ModalMobileProps, 'children'> &
  Pick<RelatedPropertiesCardListProps, 'relatedProperties'>;

const Mobile: FC<MobileProps> = ({ onClose, relatedProperties, ...rest }) => {
  return (
    <ModalMobile
      {...rest}
      onClose={onClose}
      title='Terrenos similares'
    >
      <Wrapper>
        <Container>
          <Row>
            <Col>
              <Header />

              <ContentWrapper>
                <RelatedPropertiesCardList
                  relatedProperties={relatedProperties}
                />
              </ContentWrapper>
            </Col>
          </Row>
        </Container>
        <ButtonsWrapper>
          <LeadButton />
          <CancelButton onClick={onClose} />
        </ButtonsWrapper>
      </Wrapper>
    </ModalMobile>
  );
};

export default Mobile;
